import './ModuleDetails.scss';
import { ModuleDetailsHeader } from './ModuleDetailsHeader/ModuleDetailsHeader';
import { ModuleDetailsDescription } from 'pages/LearningHub/ModuleDetails/ModuleDetailsDescription/ModuleDetailsDescription';
import { ModuleCertificates } from './ModuleCertificates/ModuleCertificates';
import { ModuleContents } from './ModuleContents/ModuleContents';
import { ModuleCTA } from 'components/ModuleCTA/ModuleCTA';
import { useParams } from 'react-router-dom';
import { isModuleCompleted, isModuleStarted } from 'utilities/learningModuleStatus';
import { useMemo } from 'react';
import { useGetModuleDetails, useGetModuleTableOfContents } from 'queryHooks/learningHub';

export const ModuleDetailsPage = () => {
  const slug = useParams().slug ?? '';
  const moduleDetails = useGetModuleDetails(slug);
  const tableOfContents = useGetModuleTableOfContents(moduleDetails.data?.id ?? '');

  const numberOfLessons = useMemo(() => tableOfContents?.data?.chapters.reduce((acc, chapter) => acc + chapter.lessons.length, 0) ?? 0, [tableOfContents?.data]);
  const numberOfChapterTests = useMemo(() =>  
    tableOfContents?.data?.chapters.reduce((acc, chapter) => {
      if (chapter.chapterTest) {
        return acc + 1;
      } else {
        return acc;
      }
    }, 0) ?? 0, [tableOfContents?.data]);
  const numberOfCertificates = useMemo(() => tableOfContents?.data?.certifications.length ?? 0, [tableOfContents?.data]);

  return (
    <>
      <ModuleDetailsHeader
        title={moduleDetails?.data?.title}
        shortDescription={moduleDetails?.data?.shortDescription}
        navigationPath='/LearningHub'
        imageUrl={moduleDetails?.data?.imageUrl}
        numberOfCertificates={numberOfCertificates}
        numberOfChapterTests={numberOfChapterTests}
        numberOfLessons={numberOfLessons}
        isPending={moduleDetails.isPending || tableOfContents.isPending}
      ></ModuleDetailsHeader>

      <div className='module-details-wrapper'>
        <>
          <div className='content'>
            <ModuleDetailsDescription
              description={moduleDetails?.data?.fullDescription}
              isPending={moduleDetails.isPending || tableOfContents.isPending}
            ></ModuleDetailsDescription>
            <ModuleCertificates
              certificationTests={moduleDetails?.data?.certificationTests}
              isPending={moduleDetails.isPending || tableOfContents.isPending}
            ></ModuleCertificates>
          </div>
          <div className='module-contents-wrapper'>
            <ModuleContents
              contents={tableOfContents.data}
              isModuleCompleted={isModuleCompleted(tableOfContents?.data)}
              isModuleStarted={isModuleStarted(tableOfContents?.data)}
              slug={slug}
              isPending={tableOfContents.isPending || tableOfContents.isPending}
            ></ModuleContents>
          </div>
          <div className='fixed-module-cta'>
            <ModuleCTA
              isModuleCompleted={isModuleCompleted(tableOfContents?.data)}
              isModuleStarted={isModuleStarted(tableOfContents?.data)}
              slug={slug}
            ></ModuleCTA>
          </div>
        </>
      </div>
    </>
  );
};
